export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_06.7574f38d.jpg";